module.exports = __webpack_public_path__ + "static/media/clubs-icon.935e9b63.svg";